//import React from 'react';
import { connect } from 'react-redux';
import ItemView from '../components/ItemView'
//import { currentUser } from '../../reducer';
//import { Redirect } from 'react-router'

const mapStateToProps = (state) => {
  return {
    //current_user_id: currentUser(state).get("id")
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    handleClick: () => {
      //
    }
  }
}

export const Item = connect(mapStateToProps,mapDipatchToProps)(ItemView);

export default Item;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/Item.js